import React from 'react'
import styles from './styles.css'
import {withRouter} from 'react-router'
import PropTypes from 'prop-types'
import MdPauseCircleOutline from 'react-icons/lib/md/pause-circle-outline'
import Tooltip from 'orionsoft-parts/lib/components/Tooltip'
import Button from 'orionsoft-parts/lib/components/Button'

@withRouter
export default class AdminButtons extends React.Component {
  static propTypes = {
    router: PropTypes.object,
    params: PropTypes.object
  }

  render() {
    return (
      <div className="content">
        <div className="row">
          <div className="col-xs-12  col-sm-3 col-md-3">
            <Button
              onClick={() =>
                this.props.router.push(
                  `/admin/${this.props.params._id}/${this.props.params.documentId}/preview`
                )
              }
            >
              Ver documento
            </Button>
          </div>
          <div className="col-xs-12  col-sm-3 col-md-3">
            <div className={styles.state}>
              <Tooltip content="El documento aún no ha sido enviado a firmar">
                <MdPauseCircleOutline size={30} style={{color: '#e4ac00'}} />
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Documents/Document/SendToSign/OwnerView/Buttons/AdminButtons/index.js